import { Avatar, Stack, Text, Truncate } from '@eleveo/components-react';
import clsx from 'clsx';
import React from 'react';

import type { AvatarProps } from '@eleveo/components-react';

type AvatarLabelProps = {
  name: string;
  description?: string;
} & AvatarProps<any>;

export const AvatarLabel = ({ className, name, description, testId, ...avatarProps }: AvatarLabelProps) => {
  return (
    <Stack className={clsx('items-center', 'min-w-0', className)} testId={testId}>
      <Avatar aria-hidden name={name} {...avatarProps} />
      <Stack className="leading-tight min-w-0" direction="vertical" spacing={0}>
        <Truncate>
          <Text weight="bold">{name}</Text>
        </Truncate>
        {description && (
          <Truncate>
            <Text color={{ light: 'grey-600', dark: 'grey-550' }}>{description}</Text>
          </Truncate>
        )}
      </Stack>
    </Stack>
  );
};
